import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	GammaSignaturesOfPetition,
	type GammaSignaturesOfPetitionQuery,
	type GammaSignaturesOfPetitionQueryVariables,
} from './useFetchSignatures.graphql';

export const fetchSignatures = async ({
	petitionId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	petitionId: string;
	utilityContext: UtilityContext;
}) => {
	try {
		const { data } = await fetch<GammaSignaturesOfPetitionQuery, GammaSignaturesOfPetitionQueryVariables>({
			query: GammaSignaturesOfPetition,
			variables: {
				petitionId,
			},
			rejectOnError: true,
			batched: false,
		});

		if (!data.signaturesDistribution.items.length) {
			throw new Error();
		}

		const { items: signaturesWithPosition } = data.signaturesDistribution;

		return { distribution: signaturesWithPosition };
	} catch {
		return null;
	}
};
